/*
 * Calls the dev-server proxy plugin (vite-plugins/vertexLocalProxy.ts) which
 * mints OAuth2 tokens from the uploaded service-account JSON and forwards to
 * Vertex AI. Browser side never sees the SA key.
 */

export interface VertexImageRequest {
  prompt: string;
  aspectRatio: string;
}

export async function vertexImage(req: VertexImageRequest): Promise<Blob> {
  const res = await fetch('/__local/vertex/imagen', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(req),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`vertexImage failed: ${res.status} ${text}`);
  }
  return res.blob();
}

export async function vertexConfigStatus(): Promise<{ ready: boolean; project?: string }> {
  try {
    const res = await fetch('/__local/vertex/status');
    if (!res.ok) return { ready: false };
    return res.json();
  } catch {
    return { ready: false };
  }
}

export async function uploadServiceAccountJson(json: string): Promise<void> {
  const res = await fetch('/__local/save-sa-json', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: json,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`uploadServiceAccountJson failed: ${res.status} ${text}`);
  }
}

export async function removeServiceAccountJson(): Promise<void> {
  const res = await fetch('/__local/save-sa-json', { method: 'DELETE' });
  if (!res.ok) {
    throw new Error(`removeServiceAccountJson failed: ${res.status}`);
  }
}
